import React from "react";
import "./readOnlyTextField.css";

export default class ReadOnlyTextField extends React.Component {
  render() {
    return (
      <div className="view Entrada">
        <label style={this.props.style}>
          <strong>{this.props.title}:</strong>
        </label>
        <div>
          <input
            className="input"
            disabled
            readOnly
            value={this.props.showValue}
            required
          ></input>
        </div>
      </div>
    );
  }
}
